<template>
  <div class="register-container">
    <div class="register-card">
      <div class="register-header">
        <h2>注册 DigitalHub</h2>
        <p>创建您的账号，开始管理知识</p>
      </div>
      
      <el-form 
        ref="registerFormRef" 
        :model="registerForm" 
        :rules="registerRules" 
        label-position="top"
        @submit.prevent="handleRegister"
      >
        <el-form-item label="用户名" prop="user_name">
          <el-input 
            v-model="registerForm.user_name" 
            placeholder="请输入用户名" 
            prefix-icon="el-icon-user"
            autocomplete="user_name"
            @input="(val) => handleInput('user_name', val)"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="邮箱" prop="email">
          <el-input 
            v-model="registerForm.email" 
            placeholder="请输入邮箱" 
            prefix-icon="el-icon-message"
            autocomplete="email"
            @input="(val) => handleInput('email', val)"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="密码" prop="user_password">
          <el-input 
            v-model="registerForm.user_password" 
            type="password" 
            placeholder="请输入密码" 
            prefix-icon="el-icon-lock"
            autocomplete="new-password"
            show-password
            @input="(val) => handleInput('user_password', val)"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="确认密码" prop="confirm_password">
          <el-input 
            v-model="registerForm.confirm_password" 
            type="password" 
            placeholder="请再次输入密码" 
            prefix-icon="el-icon-lock"
            autocomplete="new-password"
            show-password
            @input="(val) => handleInput('confirm_password', val)"
          ></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-checkbox v-model="agreeTerms" @change="validateAgree">
            我已阅读并同意 <el-button type="text" @click.prevent="showTerms">服务条款</el-button> 和 <el-button type="text" @click.prevent="showPrivacy">隐私政策</el-button>
          </el-checkbox>
          <div v-if="agreeError" class="agree-error">{{ agreeError }}</div>
        </el-form-item>
        
        <el-form-item>
          <el-button 
            type="primary" 
            native-type="submit" 
            :loading="loading" 
            class="register-button"
          >
            注册
          </el-button>
        </el-form-item>
      </el-form>
      
      <div class="register-footer">
        <p>已有账号？ <router-link to="/login">立即登录</router-link></p>
      </div>
    </div>
    
    <!-- 服务条款对话框 -->
    <el-dialog
      title="服务条款"
      v-model="termsDialogVisible"
      width="50%"
    >
      <div class="terms-content">
        <h3>DigitalHub 服务条款</h3>
        <p>最后更新日期：2023年1月1日</p>
        
        <h4>1. 接受条款</h4>
        <p>通过访问或使用DigitalHub服务，您同意受本服务条款的约束。如果您不同意这些条款，请不要使用我们的服务。</p>
        
        <h4>2. 服务描述</h4>
        <p>DigitalHub提供一个知识库管理平台，允许用户创建、组织和分享知识内容。</p>
        
        <h4>3. 用户账户</h4>
        <p>您需要创建一个账户才能使用某些功能。您负责维护您账户的保密性，并对发生在您账户下的所有活动负责。</p>
        
        <h4>4. 用户内容</h4>
        <p>您保留您在服务中创建的内容的所有权利。通过上传内容，您授予我们非排他性的许可，以便我们可以显示和处理您的内容。</p>
        
        <h4>5. 禁止行为</h4>
        <p>您不得使用我们的服务进行任何非法或未经授权的目的，或者违反任何适用的法律法规。</p>
        
        <h4>6. 终止</h4>
        <p>我们保留在任何时候因任何原因终止或暂停您访问服务的权利，恕不另行通知。</p>
        
        <h4>7. 免责声明</h4>
        <p>服务按"原样"提供，不提供任何明示或暗示的保证。</p>
        
        <h4>8. 责任限制</h4>
        <p>在法律允许的最大范围内，DigitalHub不对任何直接、间接、附带、特殊、后果性或惩罚性损害负责。</p>
        
        <h4>9. 变更</h4>
        <p>我们保留随时修改这些条款的权利。修改后的条款将在我们的网站上发布时生效。</p>
        
        <h4>10. 联系我们</h4>
        <p>如果您对这些条款有任何问题，请联系我们：support@digitalhub.com</p>
      </div>
    </el-dialog>
    
    <!-- 隐私政策对话框 -->
    <el-dialog
      title="隐私政策"
      v-model="privacyDialogVisible"
      width="50%"
    >
      <div class="privacy-content">
        <h3>DigitalHub 隐私政策</h3>
        <p>最后更新日期：2023年1月1日</p>
        
        <h4>1. 收集的信息</h4>
        <p>我们收集您提供给我们的信息，如姓名、电子邮件地址和密码，以及您使用我们服务时自动收集的信息。</p>
        
        <h4>2. 信息使用</h4>
        <p>我们使用收集的信息来提供、维护和改进我们的服务，以及与您沟通。</p>
        
        <h4>3. 信息共享</h4>
        <p>我们不会出售您的个人信息。我们可能会在以下情况下共享您的信息：经您同意、与服务提供商合作、法律要求。</p>
        
        <h4>4. 数据安全</h4>
        <p>我们采取合理措施保护您的个人信息免受未经授权的访问、使用或披露。</p>
        
        <h4>5. 您的权利</h4>
        <p>您有权访问、更正或删除您的个人信息，以及限制或反对某些处理活动。</p>
        
        <h4>6. 儿童隐私</h4>
        <p>我们的服务不面向13岁以下的儿童，我们不会故意收集13岁以下儿童的个人信息。</p>
        
        <h4>7. 变更</h4>
        <p>我们可能会不时更新我们的隐私政策。我们会通过在网站上发布新的隐私政策来通知您任何变更。</p>
        
        <h4>8. 联系我们</h4>
        <p>如果您对我们的隐私政策有任何问题，请联系我们：privacy@digitalhub.com</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default {
  name: 'Register',
  setup() {
    const store = useStore()
    const router = useRouter()
    
    // 注册表单
    const registerForm = reactive({
      user_name: '',
      email: '',
      user_password: '',
      confirm_password: ''
    })
    
    // 表单验证规则
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (registerForm.confirm_password !== '') {
          registerFormRef.value.validateField('confirm_password')
        }
        callback()
      }
    }
    
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== registerForm.user_password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    
    const registerRules = {
      user_name: [
        { required: true, message: '请输入用户名', trigger: 'blur' },
        { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
      ],
      email: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        { type: 'email', message: '请输入有效的邮箱地址', trigger: 'blur' }
      ],
      user_password: [
        { required: true, validator: validatePass, trigger: 'blur' },
        { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' }
      ],
      confirm_password: [
        { required: true, validator: validatePass2, trigger: 'blur' }
      ]
    }
    
    // 表单引用
    const registerFormRef = ref(null)
    
    // 同意条款
    const agreeTerms = ref(false)
    const agreeError = ref('')
    
    // 对话框显示状态
    const termsDialogVisible = ref(false)
    const privacyDialogVisible = ref(false)
    
    // 加载状态
    const loading = ref(false)
    
    // 验证同意条款
    const validateAgree = () => {
      agreeError.value = agreeTerms.value ? '' : '您必须同意服务条款和隐私政策'
    }
    
    // 显示服务条款
    const showTerms = () => {
      termsDialogVisible.value = true
    }
    
    // 显示隐私政策
    const showPrivacy = () => {
      privacyDialogVisible.value = true
    }
    
    // 处理注册
    const handleInput = (field, value) => {
      console.log(`Input ${field}:`, value)
      if (registerFormRef.value) {
        registerFormRef.value.validateField(field, (errorMsg) => {
          console.log(`Validation for ${field}:`, errorMsg || 'valid')
        })
      } else {
        console.warn('Form ref not available')
      }
    }
    
    // 处理注册
    const handleRegister = () => {
      // 验证同意条款
      if (!agreeTerms.value) {
        agreeError.value = '您必须同意服务条款和隐私政策'
        return
      }
      
      registerFormRef.value.validate(async (valid) => {
        if (valid) {
          loading.value = true
          console.log('Print credentials before submit: ', registerForm)
          try {
            await store.dispatch('auth/register', {
              user_name: registerForm.user_name,
              email: registerForm.email,
              user_password: registerForm.user_password
            })
            
            // 注册成功
            ElMessage.success('注册成功')
            
            // 跳转到首页
            router.push('/')
          } catch (error) {
            console.error('Registration failed:', error)
            ElMessage.error(error.response?.data?.message || '注册失败，请稍后再试')
          } finally {
            loading.value = false
          }
        } else {
          return false
        }
      })
    }
    
    return {
      registerForm,
      registerRules,
      registerFormRef,
      agreeTerms,
      agreeError,
      termsDialogVisible,
      privacyDialogVisible,
      loading,
      validateAgree,
      showTerms,
      showPrivacy,
      handleRegister,
      handleInput
    }
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.register-card {
  width: 400px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.register-header h2 {
  margin-bottom: 10px;
  color: #303133;
}

.register-header p {
  color: #606266;
  font-size: 14px;
}

.agree-error {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
}

.register-button {
  width: 100%;
}

.register-footer {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: #606266;
}

.register-footer a {
  color: #2c75b7;
  text-decoration: none;
}

.terms-content,
.privacy-content {
  max-height: 400px;
  overflow-y: auto;
  font-size: 14px;
}

.terms-content h3,
.privacy-content h3 {
  margin-top: 0;
}

.terms-content h4,
.privacy-content h4 {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>